/** Scroll containers that pin each section header to their top edge. */
export const IO_STICKY_HEADERS_CLASS =
  "[--io-header-h:calc(var(--spacing)*8)] [&_.io-message-header]:bg-surface [&_.io-message-header]:sticky [&_.io-message-header]:top-0 [&_.io-message-header]:z-10";
